import { jsx as _jsx } from "react/jsx-runtime";
import { getVariant, toText } from '../layout.js';
import { Badge as ShadcnBadge } from '../ui/badge.js';
export function Badge({ element }) {
    const { content, props } = element;
    const variant = getVariant(props);
    // Map wireframe variants to shadcn variants
    const getBadgeVariant = () => {
        switch (variant) {
            case 'primary':
                return 'default';
            case 'danger':
                return 'destructive';
            case 'success':
                return 'success';
            case 'warning':
                return 'warning';
            default:
                return 'secondary';
        }
    };
    return _jsx(ShadcnBadge, { variant: getBadgeVariant(), children: toText(content) });
}
//# sourceMappingURL=Badge.js.map